import { ButtonHandler } from "./ButtonHandler";
var HandleButtonsList = /** @class */ (function () {
    function HandleButtonsList() {
        var _this = this;
        this.formButtons = {};
        this.buttonNames = [];
        this.setNewButton = function (name, buttonParams) {
            if (typeof name !== "string") {
                HandleButtonsList.invalidNameError(name);
            }
            else if (!_this.formButtons[name]) {
                _this.buttonNames.push(name);
                _this.formButtons[name] = new ButtonHandler(buttonParams);
            }
            else {
                HandleButtonsList.buttonAlreadyExist(name);
            }
        };
        this.removeButton = function (name) {
            if (!_this.formButtons[name]) {
                HandleButtonsList.cantDeleteButton(name);
            }
            else {
                delete _this.formButtons[name];
                var nameIndex = _this.buttonNames.indexOf(name);
                _this.buttonNames.splice(nameIndex, 1);
            }
        };
        this.setButtonsStatus = function (isValidating) {
            _this.buttonNames.forEach(function (name) {
                _this.formButtons[name]._handleStatus(isValidating);
            });
        };
        this.setButtonsDisabled = function (disabled) {
            _this.buttonNames.forEach(function (name) {
                _this.formButtons[name]._setDisabledByForm(disabled);
            });
        };
    }
    HandleButtonsList.invalidNameError = function (name) {
        throw new Error("The \"form-full\" button expects to receive the \"name\" property as a string, but it received a \"" + typeof name + "\".");
    };
    HandleButtonsList.buttonAlreadyExist = function (name) {
        throw new Error("The button \"" + name + "\" has already been created.");
    };
    HandleButtonsList.cantDeleteButton = function (name) {
        throw new Error("The button \"" + name + "\" doesn't exist and cannot be removed.");
    };
    return HandleButtonsList;
}());
export { HandleButtonsList };
